import * as React from 'react';
import {Component, ReactElement} from 'react';
import {VideoSettingsLoaderScreen as LoaderScreen} from './loader-screen/loader-screen';
import {VideoSettingsErrorScreen as ErrorScreen} from './error-screen/error-screen';
import {VideoSettings, IVideoSettingsProps} from './video-settings';
import {VideoSettingsModal as Modal} from './modal/modal';
import {ITrackerProps, connectTracker} from '../../utils/tracker';
import {ERROR_SCREEN, LOADER_SCREEN} from '../../redux/modules/video-settings';

export interface IVideoSettingsContainerProps extends IVideoSettingsProps {
  context?: string;
  isOpen?: boolean;
}

interface IContainerProps extends IVideoSettingsContainerProps, ITrackerProps {}

class Container extends Component<IContainerProps, {}> {
  public static defaultProps = {
    isOpen: true,
  };

  public componentDidMount(): void {
    this.onLoad(this.props.isOpen);
  }

  public componentDidUpdate(prevProps: IContainerProps): void {
    if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen) {
      this.onLoad(this.props.isOpen);
    }
  }

  public render(): ReactElement<any> {
    const {isOpen} = this.props;

    return (
      <Modal
        isOpen={isOpen}
        onAfterOpen={this.onOpen}
        onClose={this.onClose}
      >
        {this.screen()}
      </Modal>
    );
  }

  private onClose = (): void => {
    this.props.track(this.normalizeEventName('closed'));
    this.props.onClose();
  }

  private onOpen = () => {
    this.props.track(this.normalizeEventName('opened'));
  }

  private onSave = (changes): void => {
    this.props.track(this.normalizeEventName('saved'), changes);
    this.props.onSave();
  }

  private onLoad = (isOpen: boolean) => {
    if (isOpen) {
      const {
        audioInputDeviceId,
        videoInputDeviceId,
        videoQualityId,
        loadMedia,
      } = this.props;

      loadMedia({
        audioInputDeviceId,
        videoInputDeviceId,
        videoQualityId,
      });
    }
  }

  private screen = (): ReactElement<any> => {
    const {screenType, error} = this.props;

    switch (screenType) {
      case LOADER_SCREEN:
        return (
          <LoaderScreen onClose={this.onClose} />
        );
      case ERROR_SCREEN:
        return (
          <ErrorScreen
            message={error}
            onClose={this.onClose}
          />
        );
      default:
        return (
          <VideoSettings
            {...this.props}
            onClose={this.onClose}
            onSave={this.onSave}
          />
        );
    }
  }

  private normalizeEventName = (type: string): string => {
    const context: string = this.props.context
      ? `(${this.props.context})`
      : '';

    return `${context} video settings ${type}`.trim();
  };
}

export const VideoSettingsContainer = connectTracker<IContainerProps>(Container);
